import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'educare-search',
  standalone: true,
  imports: [CommonModule, MatFormFieldModule, MatInputModule, MatIconModule],
  template: `
    <mat-form-field appearance="outline" class="w-100 edu-search">
      <input matInput [placeholder]="placeholder" (input)="onSearchInputChange($event)" class="text-muted fs-14" />
      <mat-icon matSuffix class="search-icon">search</mat-icon>
    </mat-form-field>
  `,
  styles: [
    `
      .search-icon {
        color: #a3a9b2;
      }
      .mat-mdc-form-field-input-control.mat-mdc-form-field-input-control {
        font: initial;
      }
      ::ng-deep .mat-mdc-form-field-subscript-wrapper {
        display: none !important;
      }
      mat-icon {
        padding: 0 8px 0 0 !important;
      }

      ::ng-deep .start-pad-ar {
        .mat-mdc-form-field-flex {
          padding-inline-start: 1rem;
        }
        .mdc-text-field--outlined {
          padding-left: 0 !important;
        }
      }
    `
  ]
})
export class SearchableInputComponent implements OnDestroy {
  @Input() placeholder!: string;
  @Output() searchChange = new EventEmitter<any>();

  searchInput = new Subject<string>();

  constructor() {
    this.searchInput.pipe(debounceTime(1000)).subscribe((searchTerm: string) => {
      this.performSearch(searchTerm);
    });
  }

  onSearchInputChange($event: any) {
    this.searchInput.next($event.target?.value);
  }

  performSearch(searchTerm: string) {
    this.searchChange.emit({ target: { value: searchTerm } });
  }

  ngOnDestroy() {
    this.searchInput.complete();
  }
}
